var render, staticRenderFns
import script from "./wallpaper.vue?vue&type=script&lang=coffee"
export * from "./wallpaper.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports